import { NavLink } from "react-router-dom";
import { objectKeys } from "../../../shared/utils/DateUtil";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";

interface IProps {
  details: any;
  title: string;
  levelsData: Array<any>;
  additionalLinks?: Array<{ label: string; href: string }>;
}
export default function MobileDetailsSection({
  details,
  title,
  levelsData,
  additionalLinks = [],
}: any) {
  return (
    <div className="px-4 py-2 overflow-auto">
      {/* <h3 className="text-sm text-gray-700 font-medium w-max border-b-2 border-indigo-500 py-2 pr-2">
        {title}
      </h3> */}
      <div className="py-4">
        {objectKeys(levelsData).map((key, levelIdx) => {
          let levelData = levelsData[key];
          let hasOneItem = levelData?.length === 1;
          return (
            <div
              className="flex items-start justify-between mb-4"
              key={levelIdx}
            >
              {levelData?.map((level, fieldIdx) => {
                return (
                  <div
                    className={hasOneItem ? "w-full" : "w-1/2"}
                    key={fieldIdx}
                  >
                    <p className="text-xs text-gray-400 mb-1">{level.label}</p>
                    <p className="text-xs text-gray-700">
                      {details?.[level.field] || "-"}
                    </p>
                  </div>
                );
              })}
            </div>
          );
        })}

        <div className="flex flex-wrap items-start justify-between">
          {additionalLinks?.length > 0
            ? additionalLinks.map((link, linkIdx) => {
                return (
                  <div
                    className="w-1/2 mb-5"
                    key={linkIdx}
                  >
                    <a
                      href={window.location.href+"/"+link.href!}
                      className="text-xs text-indigo-600 flex items-center justify-start"
                    >
                      {link.label}
                      <ArrowTopRightOnSquareIcon className="w-4 h-4 ml-2" />
                    </a>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
}
